import type { DriveStep } from 'driver.js';

export const customerOrderDetailTourId = 'customer:order-detail';

export const customerOrderDetailSteps: DriveStep[] = [
  {
    element: '[data-tour="customer:order-timeline"]',
    popover: {
      title: 'Статус заказа',
      description:
        'Статусы заказа. Здесь отображается полный путь вашего заказа: от создания до получения.',
    },
  },
  {
    element: '[data-tour="customer:order-qr"]',
    popover: {
      title: 'QR-код',
      description:
        'QR-код для получения. Покажите этот код сотруднику пункта выдачи, когда придёте забирать заказ. Код защищён от подделки.',
    },
  },
  {
    element: '[data-tour="customer:help-btn"]',
    popover: {
      title: 'Помощь',
      description: 'Помощь всегда рядом.',
    },
  },
];
